module.exports = __webpack_public_path__ + "img/孙康林@2x.03d54e9a.png";